import { render, staticRenderFns } from "./PrizeImage.vue?vue&type=template&id=26550276&scoped=true&"
import script from "./PrizeImage.vue?vue&type=script&lang=js&"
export * from "./PrizeImage.vue?vue&type=script&lang=js&"
import style0 from "./PrizeImage.vue?vue&type=style&index=0&id=26550276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26550276",
  null
  
)

export default component.exports